import mitt from 'mitt';

export const mittBus = mitt();

export const MITT_TYPES = {
  bannerShareCouponClick: 'bannerShareCouponClick',
};
